module.exports = __webpack_public_path__ + "static/media/180DOuline.463c94e6.png";